import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { SearchChannelsCommand, } from "../commands/SearchChannelsCommand";
export const paginateSearchChannels = createPaginator(ChimeSDKMessagingClient, SearchChannelsCommand, "NextToken", "NextToken", "MaxResults");
